import {LinkTypeProductCardSync, TabData} from "../types/product-card-sync-modal.types";
import {BaseFormField} from "../../../../../../../core/types/form-field.types";

export const tabsData: Array<TabData> = [
  {
    title: 'Синхронизированные',
    key: 'sync',
    btnKey: 'detach',
    emptyText: 'Синхронизированных карт продукта пока нет'
  },
  {
    title: 'К синхронизации',
    key: 'all',
    btnKey: 'attach',
    emptyText: 'Нет доступных карт продукта для синхронизации'
  }
]

export const productCardParamsData: Array<BaseFormField> = [
  {
    label: 'Вес',
    fieldName: 'productWeight'
  },
  {
    label: 'Цвет',
    fieldName: 'productColor'
  },
  {
    label: 'Запах',
    fieldName: 'productScent'
  },
  {
    label: 'Литраж/объём',
    fieldName: 'productVolume'
  }
]

export const paramKey = {
  productWeightId: 'productWeight' as const,
  productColorId: 'productColor' as const,
  productScentId: 'productScent' as const,
  productVolumeId: 'productVolume' as const
};

export const linkTypeProductCardSyncParams: Record<string, LinkTypeProductCardSync> = {
  productWeight: 'WEIGHT',
  productColor: 'COLOR',
  productScent: 'SCENT',
  productVolume: 'VOLUME'
}
